var amdi18n={"__root":{"ok":"Okay","back":"Back","abort":"Abort","RequestAccess":"Request Access","requestIntro":"The following site would like to get informations about the CloudID.","requestIntroConfirm":"Please confirm this request if you trust this site.","requestNoReferrer":"You are open this page directly, this isn't intended."},"__de":{"ok":"Okay","back":"Zurück","abort":"Abbrechen","RequestAccess":"Datenaustauschanfrage","requestIntro":"Die Folgende Seite möchte zugriff auf die Informationen der CloudID abfragen.","requestIntroConfirm":"Bitte bestätige den Zugriff wenn du der Seite vertraust.","requestNoReferrer":"Es ist nicht vorgesehn, dieses Seite direkt aufzurufen."}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/state/nls/RequestAccessState_strings.js
// module id = 365
// module chunks = 2